import {
  getPlatformConfig,
  type PlatformTarget,
  resolvePlatformTarget,
} from "@/lib/config/platform";

export function getAppBaseUrl(): string {
  return getPlatformConfig().appUrl;
}

export function getDeploymentEnvironmentName(): PlatformTarget {
  return resolvePlatformTarget();
}

export function isProductionDeployment(): boolean {
  return getDeploymentEnvironmentName() === "production";
}
